import { LineChart, Briefcase, Landmark, HeartPulse, Bitcoin, Coins, Wallet } from "lucide-react";

export const ACCOUNT_TYPES = [
    { value: "brokerage", label: "Brokerage", icon: LineChart, color: "#4F46E5" },
    { value: "401k", label: "401(k)", icon: Briefcase, color: "#0EA5E9" },
    { value: "ira", label: "IRA", icon: Landmark, color: "#8B5CF6" },
    { value: "hsa", label: "HSA", icon: HeartPulse, color: "#EF4444" },
    { value: "crypto", label: "Crypto", icon: Bitcoin, color: "#F59E0B" },
    { value: "savings", label: "Savings", icon: Coins, color: "#10B981" },
    { value: "other", label: "Other", icon: Wallet, color: "#94A3B8" },
];

export function accountTypeMeta(type) {
    return ACCOUNT_TYPES.find(t => t.value === type) || ACCOUNT_TYPES[ACCOUNT_TYPES.length - 1];
}

export const CHART_PALETTE = ["#4F46E5", "#10B981", "#0EA5E9", "#F59E0B", "#EF4444", "#8B5CF6", "#EC4899", "#14B8A6"];

export const RANGES = [
    { value: "1m", label: "1M" },
    { value: "3m", label: "3M" },
    { value: "6m", label: "6M" },
    { value: "1y", label: "1Y" },
    { value: "all", label: "All" },
];
